module.exports = __webpack_public_path__ + "static/pathway-91accc7bff59ed4ffd1ce4708bca5f63.jpeg";